var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { FlexBox } from "@brg/ui";
import React from "react";
import { CheckBoxWrapper, RadioInputSource, RadioBox, RadioCircle, RadioLabel } from './styles';
var RadioButton = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(CheckBoxWrapper, { disabled: props.disabled },
        React.createElement(FlexBox, { width: "100%" },
            React.createElement(RadioInputSource, __assign({}, props, { type: 'radio' })),
            React.createElement(RadioBox, __assign({}, props),
                React.createElement(RadioCircle, __assign({}, props)),
                React.createElement(FlexBox, { width: "100%" }, children)))));
};
export default RadioButton;
//# sourceMappingURL=RadioButton.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { FlexBox } from "@brg/ui";
import React from "react";
import { CheckBoxWrapper, RadioInputSource, RadioBox, RadioCircle, RadioLabel } from './styles';
var RadioButton = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(CheckBoxWrapper, { disabled: props.disabled },
        React.createElement(FlexBox, { width: "100%" },
            React.createElement(RadioInputSource, __assign({}, props, { type: 'radio' })),
            React.createElement(RadioBox, __assign({}, props),
                React.createElement(RadioCircle, __assign({}, props)),
                React.createElement(FlexBox, { width: "100%" }, children)))));
};
export default RadioButton;
//# sourceMappingURL=RadioButton.js.map